import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { LocationIcon } from '@/assets';
import { ListItem } from '@/features/list/components/ListItem';
import { PostForm } from '@/features/post-editor/constants/form';
import type { PostFormValues } from '@/features/post-editor/types/postForm';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type Props = {
  onPress: () => void;
};

/** Editor row showing the selected custom location. */
export const PostLocationField: FC<Props> = ({ onPress }) => {
  const theme = useAppTheme();
  const { t } = useTranslation(LocalizationNameSpace.POST_CREATION, {
    keyPrefix: 'screens.post-editor'
  });
  const { control } = useFormContext<PostFormValues>();

  const location = useWatch({ control, name: 'location' });

  return (
    <ListItem
      testID="post-creation-location-field"
      title={t(PostForm.LOCATION)}
      badge={location?.name}
      icon={() => (
        <LocationIcon
          fill={theme.colors.onSurfaceVariant}
          width={24}
          height={24}
        />
      )}
      onPress={onPress}
    />
  );
};
